import Step3 from './Step3-compose';

export default Step3;
